import { Card } from "../../../../../ui/card";
import { AlertCircle, Clock, CheckCircle, TrendingUp } from "lucide-react";

interface MetricsProps {
  activeTickets: number;
  urgentTickets: number;
  recoveryRate: number;
  resolvedThisMonth: number;
}

export const UrgentMetrics = ({
  activeTickets,
  urgentTickets,
  recoveryRate,
  resolvedThisMonth,
}: MetricsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <Card className="p-6 bg-gradient-to-br from-card to-card/50 border-primary/20 shadow-lg">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Active Tickets</p>
            <h3 className="text-3xl font-bold text-foreground">{activeTickets}</h3>
            <p className="text-xs text-destructive mt-1 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" />
              {urgentTickets} urgent
            </p>
          </div>
          <div className="bg-primary/10 p-3 rounded-lg">
            <AlertCircle className="h-6 w-6 text-primary" />
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-card to-card/50 border-primary/20 shadow-lg">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Recovery Rate</p>
            <h3 className="text-3xl font-bold text-foreground">{recoveryRate}%</h3>
            <p className="text-xs text-green-500 mt-1 flex items-center gap-1">
              <TrendingUp className="h-3 w-3" />
              {recoveryRate > 70 ? "Good progress" : "Needs attention"}
            </p>
          </div>
          <div className="bg-green-500/10 p-3 rounded-lg">
            <CheckCircle className="h-6 w-6 text-green-500" />
          </div>
        </div>
      </Card>

      <Card className="p-6 bg-gradient-to-br from-card to-card/50 border-primary/20 shadow-lg">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">This Month</p>
            <h3 className="text-3xl font-bold text-foreground">{resolvedThisMonth}</h3>
            <p className="text-xs text-muted-foreground mt-1">Tickets resolved</p>
          </div>
          <div className="bg-primary/10 p-3 rounded-lg">
            <TrendingUp className="h-6 w-6 text-primary" />
          </div>
        </div>
      </Card>
    </div>
  );
};
